import logoMark from '../../assets/logo-ex.svg';

type Size = 'sm' | 'lg';

const sizes: Record<Size, { mark: string; text: string }> = {
  sm: { mark: 'h-8 w-8', text: 'text-lg' },
  lg: { mark: 'h-12 w-12', text: 'text-2xl' },
};

/** Логотип Expert 3D: знак + словесная марка («Expert» тёмный, «3D» акцент). */
export function Logo({ size = 'sm', className = '' }: { size?: Size; className?: string }) {
  const s = sizes[size];
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img src={logoMark} alt="Expert 3D" className={`${s.mark} shrink-0`} />
      <span className={`font-semibold tracking-tight ${s.text}`}>
        <span className="text-primary">Expert</span>{' '}
        <span className="text-accent">3D</span>
      </span>
    </span>
  );
}
